<template>
  <div class="container">
    <!-- 顶部 -->
    <!-- <img
      src="//pic-cdn.bigdatajy.com/wenming/static/img/index2.png"
      class="top"
      alt=""
    /> -->
    <!-- <form action="javascript:return true;">
      <el-input
        placeholder="搜索关键字/关键词"
        v-model="search"
        class="search"
        type="search"
        @keyup.native.13="searchfunc">
        <i slot="prefix" style="color:white;" class="el-input__icon el-icon-search"></i>
      </el-input>
    </form> -->
    <form action="/">
      <van-search
        v-model="search"
        placeholder="请输入搜索关键词"
        @search="searchfunc"
      />
    </form>
    <div style="position: relative">
      <img
        src="//pic-cdn.bigdatajy.com/wenming/static/img/index3.png"
        style="width: 100%"
        alt=""
      />
      <div class="volunteers right">
        <span
          style="border: 1px solid white; padding: 0 5px; border-radius: 3px"
          v-show="status === 0"
          @click="urlchange('/register')"
          >加入志愿者</span
        >
        <span v-show="status == 1">欢迎回来，{{ name }}！</span>
      </div>
    </div>
    <div class="main">
      <!-- banner1 -->
      <!-- <van-swipe :autoplay="4000" class="carousel" height="30vw" :duration="500">
        <van-swipe-item v-for="(image, index) in images" :key="index" @click="bannerlink(image.link)">
          <img v-lazy="image.img" />
        </van-swipe-item>
      </van-swipe> -->
      <div class="main-right">
        <!-- new -->
        <div @click="createevent">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon01.png"
            alt=""
          />
          <span>创建活动</span>
        </div>
        <div @click="urlchange('/eventcenterdetail')">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon02.png"
            alt=""
          />
          <span>参与活动</span>
        </div>
        <div @click="urlchange('/orginazation')">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon03.png"
            alt=""
          />
          <span>志愿组织</span>
        </div>
        <div @click="urlchange('/eventcenter')">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon04.png"
            alt=""
          />
          <span>我要许愿</span>
        </div>
        <div @click="urlchange('/onlinelearn')">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon05.png"
            alt=""
          />
          <span>在线学习</span>
        </div>
        <div @click="$router.push({ name: 'sjdetail', query: { id: 1 } })">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon06.png"
            alt=""
          />
          <span>实践阵地</span>
        </div>
        <!-- <div @click="urlchange('/policy')">
          <img
            src="http://pic-cdn.bigdatajy.com/wenming/static/img/micon07.png"
            alt=""
          />
          <span>实践政策</span>
        </div> -->
        <div @click="needadmin('/organizationcheck')">
          <img src="static/img/micon09.png" alt="" />
          <span>组织审核</span>
        </div>
        <div @click="urlchange('/honor')">
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/micon08.png"
            alt=""
          />
          <span>荣誉榜单</span>
        </div>
        <!-- end -->
        <!-- <div class="pink" @click="urlchange('/orginazation')">
          <span>志愿<br>组织</span>
        </div>
        <div class="yellow">
          <span>在线<br>学习</span>
        </div>
        <div class="yellow" @click="urlchange('/policy')">
          <span>实践<br>政策</span>
        </div>
        <div class="pink" @click="urlchange('/sjzd')">
          <span>实践<br>阵地</span>
        </div> -->
      </div>
    </div>
    <!-- <div class="flexdiv">
      <p>每周志愿之星：江南小猫</p>
      <p>每周活跃组织：城市义工</p>
    </div> -->
    <!-- banner2 -->
    <van-swipe :autoplay="4000" class="carousel2" height="20vw" :duration="500">
      <van-swipe-item
        v-for="(image, index) in images2"
        :key="index"
        @click="bannerlink(image.link)"
      >
        <img :src="image.img" />
      </van-swipe-item>
    </van-swipe>
    <!-- 切换tabs -->
    <div class="tabs">
      <p
        @click="
          tab = 0;
          initnews();
        "
        :class="{ activetab: tab == 0 }"
      >
        新闻资讯
      </p>
      <p
        @click="
          tab = 1;
          initfj();
        "
        :class="{ activetab: tab == 1 }"
      >
        我的附近
      </p>
    </div>
    <!-- news -->
    <div class="tabcontainer" v-show="tab == 0">
      <van-list
        v-model="loading"
        :finished="finished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="load_more"
      >
        <div
          v-for="item in list"
          :key="item.id"
          class="list"
          @click="linketo(item.id, item.type, item.link)"
        >
          <div class="left">
            <img :src="item.img" alt="" />
          </div>
          <div class="right">
            <!-- <div class="flex" style="width: 100%">
              <span class="title">#{{ item.tag }}#</span>
              <div class="flex">
                <img
                  src="http://pic-cdn.bigdatajy.com/wenming/static/img/book.png"
                  class="book"
                  alt=""
                />
                <span>{{ item.read }}</span>
              </div>
            </div> -->
            <p class="info">{{ item.title }}</p>
            <!-- <p class="unit">{{ item.org_name }}</p> -->
            <div class="flex">
              <span class="title">#{{ item.tag }}#</span>
              <p class="date">{{ item.post_date }}</p>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <!-- 我的附近 -->
    <div class="tabcontainer" v-show="tab == 1">
      <van-list
        v-model="fjloading"
        :finished="fjfinished"
        :immediate-check="false"
        finished-text="没有更多啦"
        @load="fjload_more"
      >
        <div
          v-for="item in fjlist"
          :key="item.id"
          class="list"
          @click="linketo(item.id, item.type, item.link)"
        >
          <div class="left">
            <img :src="item.img" alt="" />
          </div>
          <div class="right">
            <!-- <div class="flex" style="width: 100%">
              <span class="title">#{{ item.tag }}#</span>
              <div class="flex">
                <img
                  src="http://pic-cdn.bigdatajy.com/wenming/static/img/book.png"
                  class="book"
                  alt=""
                />
                <span>{{ item.read }}</span>
              </div>
            </div> -->
            <p class="info">{{ item.title }}</p>
            <!-- <p class="unit">{{ item.org_name }}</p> -->
            <div class="flex">
              <span class="title">#{{ item.tag }}#</span>
              <p class="date">{{ item.post_date }}</p>
            </div>
          </div>
        </div>
      </van-list>
    </div>
    <img
      src="static/img/sign_icon.png"
      class="signicon"
      alt=""
      @click="$router.push('/signlist')"
    />
    <!-- 底部 -->
    <div class="footer" v-show="hideshow">
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icona01.png"
          class="icon"
          alt=""
          @click="urlchange('/')"
        />
        <p style="color: #1646c0">首页</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon02.png"
          class="icon"
          alt=""
          @click="urlchange('/cfshow')"
        />
        <p>澄风show</p>
      </div>
      <van-popover
        v-model="showPopover"
        trigger="click"
        :actions="actions"
        @select="onSelect"
        placement="top"
      >
        <template #reference>
          <img
            src="//pic-cdn.bigdatajy.com/wenming/static/img/icon05.png"
            style="width: 45px; height: 35px"
            alt=""
          />
        </template>
      </van-popover>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon03.png"
          class="icon"
          alt=""
          @click="urlchange('/eventcenterdetail')"
        />
        <p>活动中心</p>
      </div>
      <div>
        <img
          src="//pic-cdn.bigdatajy.com/wenming/static/img/icon04.png"
          class="icon"
          alt=""
          @click="urlchange('/center')"
        />
        <p>我的家园</p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "home",
  data() {
    return {
      search: "",
      status: "",
      images: [],
      images2: [],
      tab: 0,
      list: [],
      fjlist: [],
      appId: "2312",
      url: "",
      img: "",
      name: "",
      count: "",
      loading: false,
      finished: false,
      page: 1,
      fjloading: false,
      fjfinished: false,
      fjpage: 1,
      docmHeight: document.documentElement.clientHeight, //默认屏幕高度
      showHeight: document.documentElement.clientHeight, //实时屏幕高度
      hideshow: true, //显示或者隐藏footer
      isResize: false, //默认屏幕高度是否已获取
      showPopover: false,
      actions: [
        { text: "发布报告", icon: "notes-o", className: "0" },
        { text: "发布心愿", icon: "exchange", className: "1" },
        { text: "我的收藏", icon: "like-o", className: "2" },
      ],
      admin: 0,
    };
  },
  created() {
    var that = this;
    //app
    this.url = "//zhuzhan.ijiangyin.com/siteapp/appClient/sign";

    zjyapi.init({
      appId: that.appId,
      error: function (code, ret) {
        //失败回调,默认
        alert("初始化失败");
      },
      success: function success(ret) {
        that.queryUserInfoBasic();
      },
    });
    this.indexinit();
    //新闻
    this.$axios({
      method: "post",
      url: "/api/news/list",
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.list = res.data.data.list;
      }
    });
    //我的附近
    this.$axios({
      method: "post",
      url: "/api/news/fujin_list",
    }).then((res) => {
      console.log(res.data);
      if (res.data.code == 0) {
        this.fjlist = res.data.data.list;
      }
    });
  },
  mounted() {
    // window.onresize监听页面高度的变化
    window.onresize = () => {
      return (() => {
        if (!this.isResize) {
          this.docmHeight = document.documentElement.clientHeight;
          this.isResize = true;
        }
        this.showHeight = document.body.clientHeight;
        console.log(this.showHeight);
      })();
    };
  },
  watch: {
    showHeight: function () {
      if (this.docmHeight >= this.showHeight) {
        this.hideshow = false;
      } else {
        this.hideshow = true;
      }
      console.log(this.hideshow);
    },
  },
  methods: {
    indexinit() {
      var that = this;
      that
        .$axios({
          method: "post",
          url: "/api/index/index",
        })
        .then((res) => {
          console.log(res.data);
          if (res.data.code == 0) {
            for (let i in res.data.data.banner_list) {
              switch (res.data.data.banner_list[i].place) {
                case "index_left":
                  that.images.push(res.data.data.banner_list[i]);
                  break;
                case "index_mid":
                  that.images2.push(res.data.data.banner_list[i]);
                  break;
                default:
                  break;
              }
            }
            that.$forceUpdate();
          } else {
            that.$toast(res.data.msg);
          }
        });
    },
    onSelect(action) {
      console.log(action);
      if (action.className == 0) {
        this.$router.push("/mywishlist");
      }
      if (action.className == 1) {
        this.$router.push("/applywish");
      }
      if (action.className == 2) {
        this.$router.push("/myfav");
      }
    },
    bannerlink(link) {
      location.href = link;
    },
    urlchange(url) {
      if (url == "/center") {
        if (this.status == 0 || this.status == "") {
          this.$toast("请先加入志愿者");
          return;
        }
      }
      this.$router.push(url);
    },
    //app相关开始
    //获取签名方法
    getSign: function (fun) {
      /*请求参数*/
      var paramObj = {
        httpUrl: this.url,
        type: "post",
        data: {
          appId: this.appId,
        },
      };
      /*请求调用*/
      this.httpRequest(paramObj, fun, function () {
        alert("获取签名失败错误");
      });
    },
    httpRequest: function (paramObj, fun, errFun) {
      var xmlhttp = null;
      /*创建XMLHttpRequest对象，
       *老版本的 Internet Explorer（IE5 和 IE6）使用 ActiveX 对象：new ActiveXObject("Microsoft.XMLHTTP")
       * */
      if (window.XMLHttpRequest) {
        xmlhttp = new XMLHttpRequest();
      } else if (window.ActiveXObject) {
        xmlhttp = new ActiveXObject("Microsoft.XMLHTTP");
      }
      /*判断是否支持请求*/
      if (xmlhttp == null) {
        alert("你的浏览器不支持XMLHttp");
        return;
      }
      /*请求方式，并且转换为大写*/
      var httpType = (paramObj.type || "GET").toUpperCase();
      /*数据类型*/
      var dataType = paramObj.dataType || "json";
      /*请求接口*/
      var httpUrl = paramObj.httpUrl || "";
      /*是否异步请求*/
      var async = paramObj.async || true;
      /*请求参数--post请求参数格式为：foo=bar&lorem=ipsum*/
      var paramData = paramObj.data || [];
      var requestData = "";
      for (var name in paramData) {
        requestData += name + "=" + paramData[name] + "&";
      }
      requestData =
        requestData == ""
          ? ""
          : requestData.substring(0, requestData.length - 1);
      console.log(requestData);
      /*请求接收*/
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200) {
          /*成功回调函数*/
          //获取签名数据成功:{"serverTime":null,"error":"200","msg":"成功","data":{"appSign":"b37808616bda9d71e100e0971881101d","appId":"2312""timestamp":1575953679723},"map":null}
          console.log("获取签名数据成功:" + xmlhttp.responseText);
          var obj = JSON.parse(xmlhttp.responseText);
          var data = obj.data;
          fun({
            timestamp: data.timestamp,
            sign: data.appSign,
          });
        } else {
          /*失败回调函数*/
          errFun;
        }
      };
      /*接口连接，先判断连接类型是post还是get*/
      if (httpType == "GET") {
        xmlhttp.open("GET", httpUrl, async);
        xmlhttp.send(null);
      } else if (httpType == "POST") {
        xmlhttp.open("POST", httpUrl, async);
        //发送合适的请求头信息
        xmlhttp.setRequestHeader(
          "Content-type",
          "application/x-www-form-urlencoded"
        );
        xmlhttp.send(requestData);
      }
    },
    queryUserInfoBasic: function () {
      var that = this;
      this.getSign(function (sign) {
        that.$toast.loading({
          duration: 0,
          forbidClick: true,
        });
        zjyapi.queryUserInfoBasic({
          sign: sign,
          params: {
            type: "1",
          },
          success: function (ret) {
            console.log("获取用户信息成功：" + ret);
            var data = JSON.parse(ret);
            if (data.uid) {
              sessionStorage.setItem("uid", data.uid);
            } else {
              alert("请登录app");
            }
            sessionStorage.setItem("mobile", data.mobile);
            sessionStorage.setItem("img", data.headimg);
            console.log(ret);
            console.log(JSON.parse(ret));

            that
              .$axios({
                method: "post",
                url: "/api/member/login_app",
                data: that.qs.stringify({
                  zjyuid: data.uid,
                  mobile: data.mobile,
                }),
              })
              .then((res) => {
                that.$toast.clear();
                console.log(res.data);
                if (res.data.code == 0) {
                  sessionStorage.setItem("wmtoken", res.data.data.token);
                  sessionStorage.setItem("wmmember", res.data.data);
                  //判断是否为志愿者
                  let obj = {};
                  obj = {
                    zjyuid: sessionStorage.getItem("uid"),
                    mobile: sessionStorage.getItem("mobile"),
                    token: sessionStorage.getItem("wmtoken"),
                  };
                  that
                    .$axios({
                      method: "post",
                      url: "/api/index/index",
                      data: that.qs.stringify(obj),
                    })
                    .then((res) => {
                      console.log(res.data);
                      if (res.data.code == 0) {
                        that.admin = res.data.data.isadmin;
                        console.log("admin:" + res.data.data.isadmin);
                        console.log(res.data.data.member);
                        that.status = 0;
                        if (res.data.data.member) {
                          console.log("111");
                          that.status = 1;
                          that.name = res.data.data.member.name;
                        } else {
                          that.status = 0;
                        }
                        that.count = res.data.data.member_count;
                        /* for (let i in res.data.data.banner_list) {
                          switch (res.data.data.banner_list[i].place) {
                            case "index_left":
                              that.images.push(res.data.data.banner_list[i]);
                              break;
                            case "index_mid":
                              that.images2.push(res.data.data.banner_list[i]);
                              break;
                            default:
                              break;
                          }
                        } */
                        that.$forceUpdate();
                      } else {
                        that.$toast(res.data.msg);
                      }
                    });
                } else {
                  that.status = 0;
                  //that.$toast(res.data.msg);
                }
              });
          },
          error: function (error) {
            console.log("获取用户信息失败：" + JSON.stringify(error));
          },
        });
      });
    },
    //end
    //app相关结束
    //搜索
    searchfunc() {
      this.$router.push({
        name: "searchresult",
        query: {
          keyword: this.search,
        },
      });
    },
    linketo(id, type, url) {
      if (type == 1) {
        this.$router.push({
          name: "newsdetail",
          query: {
            id: id,
          },
        });
      } else {
        this.$axios({
          method: "post",
          url: "/api/news/click",
          data: this.qs.stringify({
            id: id,
            zjy_uid: sessionStorage.getItem("uid"),
          }),
        }).then((res) => {
          console.log(res.data);
          location.href = url;
        });
      }
    },
    initnews() {
      this.page = 1;
      this.list = [];
      this.finished = false;
      this.loading = false;
      this.$axios({
        method: "post",
        url: "/api/news/list",
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.list = res.data.data.list;
        }
      });
    },
    initfj() {
      this.fjpage = 1;
      this.fjlist = [];
      this.fjfinished = false;
      this.fjloading = false;
      this.$axios({
        method: "post",
        url: "/api/news/fujin_list",
      }).then((res) => {
        console.log(res.data);
        if (res.data.code == 0) {
          this.fjlist = res.data.data.list;
        }
      });
    },
    load_more() {
      this.page += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/news/list",
            data: that.qs.stringify({
              page: that.page,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0) {
              that.list = that.list.concat(res.data.data.list);
            }
            that.loading = false;
            if (res.data.data.list.length == 0) {
              //数据全部加载完成
              that.finished = true;
            } else {
              that.finished = false;
            }
          });
      }, 500);
    },
    fjload_more() {
      this.fjpage += 1;
      var that = this;
      setTimeout(function () {
        that
          .$axios({
            method: "post",
            url: "/api/news/fujin_list",
            data: that.qs.stringify({
              page: that.fjpage,
            }),
          })
          .then((res) => {
            console.log(res.data);
            if (res.data.code == 0 && res.data.data.list) {
              that.fjlist = that.fjlist.concat(res.data.data.list);
            }
            that.fjloading = false;
            if (!res.data.data.list || res.data.data.list.length == 0) {
              //数据全部加载完成
              that.fjfinished = true;
            } else {
              that.fjfinished = false;
            }
          });
      }, 500);
    },
    createevent() {
      if (this.admin == 0) {
        this.$toast("暂无权限");
      } else {
        this.$router.push("/createevent");
      }
    },
    needadmin(url) {
      if (this.admin == 0) {
        this.$toast("暂无权限");
      } else {
        this.$router.push(url);
      }
    },
  },
};
</script>
<style scoped>
.container {
  background: #f2f2f2;
  min-height: 100vh;
}
img {
  width: 100%;
  display: block;
}
.search {
  position: relative;
  bottom: 80px;
  width: 90%;
  margin: 0 auto;
  display: block;
}
.search /deep/ .el-input__inner {
  background: rgba(255, 255, 255, 0.3);
  border: none;
  color: white;
}
.search ::placeholder {
  color: white;
}
.volunteers {
  position: absolute;
  top: 0;
  right: 5%;
  height: 40px;
  color: white;
  width: 90%;
  margin: 0 auto;
  display: flex;
  align-items: center;
}
.right {
  flex-direction: row-reverse;
}
/* vue-touch不能上下滑动的问题 */
.wrapper {
  touch-action: pan-y !important;
  height: 100%;
}
.menu-container {
  height: 100%;
}
.main {
  background: white;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 10px;
  border-radius: 10px;
  margin-top: -25px;
  position: relative;
}
.main .carousel {
  width: 55vw;
}
.carousel img {
  height: 100%;
}
.main-right {
  width: 100%;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.main-right div {
  width: 25%;
  margin: 10px auto;
  color: #333;
  /* display: flex;
  justify-content: center;
  align-items: center; */
  font-weight: 400;
  font-size: 14px;
  line-height: 16px;
}
.main-right img {
  width: 40px;
  height: 40px;
  margin: 10px auto;
}
.main-right span {
  display: block;
  text-align: center;
}
.pink {
  /* background: #EE8B73; */
  background: #52a0f5;
}
.yellow {
  background: #eeb951;
}
.flexdiv {
  display: flex;
  padding: 10px;
  background: white;
  align-items: center;
  justify-content: space-between;
}
.flexdiv p {
  width: 45%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-size: 14px;
}
.carousel2 {
  width: 95%;
  margin: 10px auto;
}
.carousel2 img {
  height: 100% !important;
}
.tabs {
  /* width: 100%; */
  margin: 0 10px;
  display: flex;
  align-items: center;
  height: 35px;
  line-height: 35px;
  background: #f2f2f2;
}
.tabs p {
  width: 50%;
  text-align: center;
}
.activetab {
  font-weight: bold;
  background: white;
}
.tabcontainer {
  background: white;
  padding: 10px;
  margin: 0 10px;
  margin-bottom: 60px;
}
.list {
  display: flex;
  margin-bottom: 10px;
  height: 75px;
  justify-content: space-between;
  font-family: "newfontnormal";
}
.list .left {
  width: 33%;
}
.list .left img {
  height: 100%;
  width: 100%;
  display: block;
  object-fit: cover;
  border-radius: 5px;
}
.list .right {
  width: 64%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.list .flex {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.info,
.unit {
  width: 100%;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.info {
  color: #333333;
}
.book {
  height: 20px;
  width: auto;
}
.date,
.unit,
.title {
  font-size: 14px;
}
.date {
  color: #999999;
  text-align: right;
  white-space: nowrap;
}
.unit {
  text-align: right;
}
.title {
  color: #1646c0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 50px;
  font-size: 12px;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  color: #434343;
  background: white;
}
/* .footer p {
  font-size: 0.289855rem;
} */
.footer div {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 20%;
}
.icon {
  width: 20px;
  height: 20px;
}
.zyz {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  align-items: center;
  margin-top: -70px;
  background: white;
  margin-bottom: 10px;
  font-size: 4vw;
}
.zyz span {
  color: red;
  font-weight: bold;
  font-size: 6vw;
}
.signicon {
  width: 56px;
  height: 56px;
  position: fixed;
  right: 18px;
  bottom: 140px;
}
</style>


// WEBPACK FOOTER //
// src/components/home.vue